import { HttpClient, provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { GuestAppComponent } from './guest-app.component';
import { GuestAppRoutingModule } from './guest-app-routing.module';

/**
 * Guest Application Module
 *
 * Minimal module configuration for unauthenticated guest access to meetings.
 * This module intentionally excludes:
 * - Authentication services and guards
 * - HTTP interceptors that could trigger auth flows
 * - WebSocket services and real-time connections
 * - App initialization logic that requires authentication
 * - Service worker registration
 *
 * Only includes what's necessary for guest meeting functionality:
 * - Basic HTTP client (without auth interceptors)
 * - Translation support for i18n
 * - Routing to guest meeting components
 * - Material design components as needed
 *
 * This ensures guest users can join meetings without any possibility
 * of triggering authentication flows or redirects.
 */

@NgModule({
  declarations: [GuestAppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    GuestAppRoutingModule,
    // Translation support for guest UI
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          // Use relative path for file:// protocol (Electron), absolute path for http(s)://
          const prefix = window.location.protocol === 'file:' ? './assets/i18n/' : '/assets/i18n/';
          return new TranslateHttpLoader(http, prefix, '.json');
        },
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    // Provide HTTP client WITHOUT auth interceptors
    provideHttpClient(),
    // No APP_INITIALIZER - guest app starts immediately
    // No AuthGuard or auth-related services
    // No WebSocket or real-time services
  ],
  bootstrap: [GuestAppComponent],
})
export class GuestAppModule {
  constructor() {
    console.log('[GUEST-APP-MODULE] Guest application module initialized');
  }
}
